import axios from 'axios'
import Logout from './Logout';

let ApiHelper = axios.create()

ApiHelper.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
})

ApiHelper.interceptors.response.use((response => {
    return response
}), err => {
    console.log('Error: ', err);
    if (err?.response?.status === 401) {
        Logout()
    }
    throw err;
})

export default ApiHelper